export const MIN_LENGTH_PASSWORD = 6

export const MIN_LENGTH_PASSWORD_MESSAGE = `Password must be at least ${MIN_LENGTH_PASSWORD} characters`

// TEMP (OTP disabled): Twilio prod fails with error 20003 (Authenticate). Disables OTP/phone
// verification site-wide: drops the OTP requirement, hides the phone field on register, and
// bypasses the /auth/verify-phone page. Set back to false to restore the full verify-phone flow.
export const OTP_DISABLED = true
